import React from 'react';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconBaseProps, IconRender } from '../types.ts';

const Chat = React.forwardRef<SVGSVGElement | null, IconBaseProps>(function Chat({ dataTestId, ...props }, ref) {
  const iconRender = useCallbackRef<IconRender>((color: string) => (
    <>
      <path
        d='M8.25 12.75C8.94036 12.75 9.5 12.1904 9.5 11.5C9.5 10.8096 8.94036 10.25 8.25 10.25C7.55964 10.25 7 10.8096 7 11.5C7 12.1904 7.55964 12.75 8.25 12.75Z'
        fill={color}
      />
      <path
        d='M13.5 11.5C13.5 12.1904 12.9404 12.75 12.25 12.75C11.5596 12.75 11 12.1904 11 11.5C11 10.8096 11.5596 10.25 12.25 10.25C12.9404 10.25 13.5 10.8096 13.5 11.5Z'
        fill={color}
      />
      <path
        d='M16.25 12.75C16.9404 12.75 17.5 12.1904 17.5 11.5C17.5 10.8096 16.9404 10.25 16.25 10.25C15.5596 10.25 15 10.8096 15 11.5C15 12.1904 15.5596 12.75 16.25 12.75Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.5 4.5C2.80964 4.5 2.25 5.05964 2.25 5.75V20.9193C2.25 22.0735 3.68067 22.611 4.44072 21.7424L7.27783 18.5H20.5C21.1904 18.5 21.75 17.9404 21.75 17.25V5.75C21.75 5.05964 21.1904 4.5 20.5 4.5H3.5ZM3.75 20.2539V6.5C3.75 6.22386 3.97386 6 4.25 6H19.75C20.0261 6 20.25 6.22386 20.25 6.5V16.5C20.25 16.7761 20.0261 17 19.75 17H7.16438C6.80393 17 6.46102 17.1556 6.22366 17.4269L3.75 20.2539Z'
        fill={color}
      />
    </>
  ));
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'chat-icon-svg'} iconRender={iconRender} {...props} />;
});

export default Chat;
